<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建投放计划</el-button>
        </li>
        <li v-if="isSspUser">
          <span>所属广告主：</span>
          <el-select size="small" v-model="queryUser" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in userData" :label="item.advertiserName" :value="item.advertiserId" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>投放计划名称：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryPlanName" @input="getList"></el-input>
        </li>
        <li>
          <span>状态：</span>
          <el-select size="small" v-model="queryStatus" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in myOption.status" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="ListMain-table-expand">
              <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="最后修改时间">
                <span>{{ props.row.updateTime }}</span>
              </el-form-item>
              <el-form-item label="修改人">
                <span>{{ props.row.modifier }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="planId" label="ID" min-width="100px"></el-table-column>
        <el-table-column prop="planName" label="投放计划名称" min-width="200px"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" min-width="170px"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" min-width="170px"></el-table-column>
        <el-table-column label="投放单元统计" min-width="150px">
          <el-button v-if="unitPower" type="text" size="mini" slot-scope="scope" @click="jumpUnit(scope.row)">{{scope.row.putUnitNum}}</el-button>
          <span v-else>{{scope.row.putUnitNum}}</span>
        </el-table-column>
        <el-table-column prop="dayBudget" label="每日预算" min-width="150px"></el-table-column>
        <el-table-column label="状态" min-width="100px">
          <template slot-scope="scope">
            <el-switch v-model="tableData[scope.$index].status" :disabled="!statusPower" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="setStatus(tableData[scope.$index])"></el-switch>
          </template>
        </el-table-column>
        <el-table-column v-if="addPower || deletePower || modifyPower" min-width="150px">
          <template slot="header" slot-scope="scope">
            操作
            <i class="el-icon-question" title="投放单元统计 >0 时，禁用删除操作"></i>
          </template>
          <template slot-scope="scope">
            <!--<el-button v-if="addPower" type="text" size="small" style="color:#67C23A;" @click="setAddAndModify(tableData[scope.$index], true)">复制</el-button>-->
            <el-button v-if="modifyPower" type="text" size="small" @click="setAddAndModify(tableData[scope.$index])">修改</el-button>
            <el-button v-if="deletePower && tableData[scope.$index].putUnitNum===0" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isSspUser: this.$store.getters.isMediaOwner,
      isLoading: true,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      statusPower: false,
      unitPower: false,
      userData: [],
      queryUser: '',
      queryStatus: '',
      queryPlanName: ''
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.plan.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      console.log(powers)
      let power = powers[1100].powerValue
      // 新建
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
      // 启用/禁用
      if ((power & thisModule.status.power) === thisModule.status.power) {
        this.statusPower = true
      }
      // 投放单元跳转
      const unitPower = powers[500].powerValue
      const unitPowerList = this.myOption.requestModule.unit.children.list.power
      if ((unitPower & unitPowerList) === unitPowerList) {
        this.unitPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 获取缓存筛选数据
    this.myOption.getScreenData(this, 'screen-plan')
    // 判断是否为媒体主
    if (this.isSspUser) {
      this.getAdOwnerList().then(() => {
        // 调用获取列表函数
        this.getList()
      })
    } else {
      // 调用获取列表函数
      this.getList()
    }
  },
  methods: {
    // 获取广告主列表
    getAdOwnerList () {
      return new Promise((resolve) => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.list.id
          },
          url: this.myOption.requestUrl + this.thisModule.list.user,
          data: this.qs.stringify({
            startPage: 1,
            pageSize: this.myOption.pageSize.max
          })
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            this.userData = res.data.data.data
            this.myOption.appendSelectAllItem('advertiser', this.userData)
            if (this.$route.path.indexOf('/list') > -1 && !this.queryUser) {
              try {
                this.queryUser = this.userData[0].advertiserId
                resolve && resolve()
              } catch (e) {
                this.isLoading = false
              }
            } else {
              resolve && resolve()
            }
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      })
    },
    // 获取列表
    getList () {
      let param = {
        planName: this.queryPlanName,
        status: this.queryStatus,
        startPage: this.$store.state.user.currentPage,
        pageSize: this.$store.state.user.pageSize
      }
      if (this.isSspUser) {
        param.advertiserId = this.queryUser
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify(param)
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            val.slotType = this.myOption.getIdData('slotType', val.slotType, 'name')
            val.startTime = this.myOption.writeCurrentDate(val.startTime)
            val.endTime = this.myOption.writeCurrentDate(val.endTime)
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 新增和修改
    setAddAndModify (data, isCopy) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.planId, copy: isCopy || false})
      }
      let param = {}
      if (this.queryUser !== '') {
        param.queryUser = this.queryUser
      }
      if (this.queryPlanName !== '') {
        param.queryPlanName = this.queryPlanName
      }
      if (this.queryStatus !== '') {
        param.queryStatus = this.queryStatus
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-plan', JSON.stringify(param))
      }
      this.myOption.switchListAndEdit(this, false)
    },
    // 删除
    setDelete (param) {
      this.$confirm(`是否删除 "${param.planName}" 投放计划`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            planIds: param.planId
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除投放计划成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    },
    // 启用/禁用
    setStatus (param) {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.status.id
        },
        url: this.myOption.requestUrl + this.thisModule.status.api,
        data: this.qs.stringify({
          planId: param.planId,
          status: param.status
        })
      }).then(res => {
        const code = res.data.code
        if (res.data.code === 200) {
          this.$message.success(`${param.status === 1 ? '启用' : '禁用'}投放计划成功`)
        } else {
          this.myOption.abnormalCode(this, code)
          param.status = !param.status
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        param.status = !param.status
      })
    },
    // 跳转投放单元
    jumpUnit (param) {
      this.$router.push({
        path: '/unit/list',
        name: '投放单元管理',
        params: {
          planId: param.planId,
          advertiserId: this.queryUser
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/plan/List.vue